import { render, staticRenderFns } from "./_sns_social.vue?vue&type=template&id=5df0d1c6&"
import script from "./_sns_social.vue?vue&type=script&lang=js&"
export * from "./_sns_social.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports